import React, { useState, useContext, useEffect } from 'react';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Stack,
  LinearProgress,
} from '@mui/material';
import { StarOutline, Star } from '@mui/icons-material/';
import { toast } from 'react-toastify';
// Components
import TableTextField from './TableTextField';
// Context
import { useMdProfileContext } from '../context/useMdProfileContext';
// API
import { getDoctorInfo } from '../../../api/mdProfileApi';

const cellHeader = {
  backgroundColor: '#b5d7b5',
  fontWeight: 'bold',
  border: '1px solid #999',
  width: '15%',
  whiteSpace: 'nowrap',
};

export default function ProfessionlInfoTab() {
  const { viewProfile, professionalform, setProfessionalform } = useContext(useMdProfileContext);

  const editable = false;
  const [loading, setLoading] = useState(false);

  const cellInput = {
    border: '1px solid #999',
    backgroundColor: editable ? '#f9fff9' : '#ebeeebff',
    padding: 0,
    height: 52,
  };

  const loadDoctorInfo = async () => {
    try {
      setLoading(true);
      const request = {
        doctor_id: viewProfile?.doctor_id,
        info_type: 'prof',
      };

      const resposne = await getDoctorInfo(request);
      const { code, data } = resposne.data;

      if (code === '200') {
        setLoading(false);
        setProfessionalform((prevState) => ({
          ...prevState,
          ...data,
        }));
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    loadDoctorInfo();
  }, [viewProfile]);

  return (
    <Box>
      {loading ? (
        <LinearProgress />
      ) : (
        <Grid container spacing={1}>
          <Grid item md={8} marginBottom={2}>
            <TableContainer component={Paper} sx={{ width: '100%' }}>
              <Table>
                <TableBody>
                  {/* Row 1 */}
                  <TableRow>
                    <TableCell sx={cellHeader}>PRC ID</TableCell>
                    <TableCell colSpan={2} sx={cellInput}>
                      <TableTextField
                        value={professionalform?.prc_id}
                        name='prc_id'
                        placeholder='N/A'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellHeader}>Issuance Date</TableCell>
                    <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                      <TableTextField
                        type='text'
                        name='issuance_date'
                        value={professionalform?.prc_id_issuance_date}
                        placeholder='Date'
                        editable={editable}
                      />
                    </TableCell>
                  </TableRow>

                  {/* Row 2 */}
                  <TableRow>
                    <TableCell sx={cellHeader}>PTR No.</TableCell>
                    <TableCell colSpan={2} sx={cellInput}>
                      <TableTextField
                        value={professionalform?.ptr_no}
                        name='ptr_no'
                        placeholder='N/A'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellHeader}>PTR Expiration</TableCell>
                    <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                      <TableTextField
                        type='text'
                        name='ptr_expiration'
                        value={professionalform?.ptr_no_exp}
                        placeholder='Date'
                        editable={editable}
                      />
                    </TableCell>
                  </TableRow>

                  {/* Row 3 */}
                  <TableRow>
                    <TableCell sx={cellHeader}>Cicerone</TableCell>
                    <TableCell colSpan={6} sx={cellInput}>
                      <TableTextField
                        value={professionalform?.cicerone_name}
                        name='cicerone'
                        placeholder='N/A'
                        editable={editable}
                        hideable
                      />
                    </TableCell>
                  </TableRow>

                  {/* Row 4 */}
                  <TableRow>
                    <TableCell sx={cellHeader}>Mobile No.</TableCell>
                    <TableCell colSpan={6} sx={cellInput}>
                      <TableTextField
                        type='number'
                        value={professionalform?.mobile_primary}
                        name='mobile_no'
                        placeholder='N/A'
                        editable={editable}
                        hideable
                      />
                    </TableCell>
                  </TableRow>

                  {/* Row 5 */}
                  <TableRow>
                    <TableCell sx={cellHeader}>Landline</TableCell>
                    <TableCell colSpan={2} sx={cellInput}>
                      <TableTextField
                        value={professionalform?.landline}
                        name='landline'
                        placeholder='N/A'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellHeader}>Email Address 1</TableCell>
                    <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                      <TableTextField
                        type='text'
                        name='email_ad_primary'
                        value={professionalform?.email_ad_primary}
                        placeholder='Date'
                        editable={editable}
                        hideable
                      />
                    </TableCell>
                  </TableRow>

                  {/* Row 7 */}
                  <TableRow>
                    <TableCell sx={cellHeader}>Pre. Comm Channel</TableCell>
                    <TableCell colSpan={2} sx={cellInput}>
                      <TableTextField
                        value={professionalform?.pref_comm_channel}
                        name='pref_comm_channel'
                        placeholder='N/A'
                        editable={editable}
                      />
                    </TableCell>
                    <TableCell sx={cellHeader}>Email Address 2</TableCell>
                    <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                      <TableTextField
                        type='text'
                        name='email_ad_secondary'
                        value={professionalform?.email_ad_secondary}
                        placeholder='Email Address 2'
                        editable={editable}
                        hideable
                      />
                    </TableCell>
                  </TableRow>

                  {/*  */}
                  <TableRow sx={{ backgroundColor: '#f0df47ff' }}>
                    <TableCell colSpan='100%' sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                      CLINIC INFORMATION
                    </TableCell>
                  </TableRow>
                  {/*  */}
                  {professionalform?.clinics?.map((row) => (
                    <>
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          sx={{
                            border: '1px solid #999',
                            padding: 0,
                            height: 52,
                            backgroundColor: '#cae7ecff',
                          }}
                        >
                          <TableTextField
                            value={row?.name}
                            name='clinic_name'
                            placeholder='N/A'
                            editable={editable}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            border: '1px solid #999',
                            padding: 0,
                            height: 52,
                            backgroundColor: '#cae7ecff',
                          }}
                        >
                          <Stack direction='row' justifyContent='center' gap={1}>
                            {row?.is_primary ? (
                              <Star sx={{ color: '#a9b322ff' }} />
                            ) : (
                              <StarOutline sx={{ color: '#a9b322ff' }} />
                            )}
                          </Stack>
                        </TableCell>
                      </TableRow>

                      {/* Row 9 */}
                      <TableRow>
                        <TableCell sx={cellHeader}>Bulding Name/No.</TableCell>
                        <TableCell colSpan={2} sx={cellInput}>
                          <TableTextField
                            value={row?.address_st_bldg_name_no}
                            name='address_st_bldg_name_no'
                            placeholder='Bulding Name/No'
                            editable={editable}
                          />
                        </TableCell>
                        <TableCell sx={cellHeader}>Floor/Room No.</TableCell>
                        <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                          <TableTextField
                            type='text'
                            name='address_floor_room_no'
                            value={row?.address_floor_room_no}
                            placeholder='Floor/Room No.'
                            editable={editable}
                          />
                        </TableCell>
                      </TableRow>

                      {/* Row 10 */}
                      <TableRow>
                        <TableCell sx={cellHeader}>City</TableCell>
                        <TableCell colSpan={2} sx={cellInput}>
                          <TableTextField
                            value={row?.address_city}
                            name='city'
                            placeholder='City'
                            editable={editable}
                          />
                        </TableCell>
                        <TableCell sx={cellHeader}>Province</TableCell>
                        <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                          <TableTextField
                            type='text'
                            name='address_province'
                            value={row?.address_province}
                            placeholder='Province'
                            editable={editable}
                          />
                        </TableCell>
                      </TableRow>

                      {/* Row 10 */}
                      <TableRow>
                        <TableCell sx={cellHeader}>Med Secretary Name</TableCell>
                        <TableCell colSpan={2} sx={cellInput}>
                          <TableTextField
                            value={row?.medsec_name}
                            name='secretary_name'
                            placeholder='Med Secretary Name'
                            editable={editable}
                          />
                        </TableCell>
                        <TableCell sx={cellHeader}>Mobile No.</TableCell>
                        <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                          <TableTextField
                            type='text'
                            name='mobile_no'
                            value={row?.mobile_no}
                            placeholder='Mobile No.'
                            editable={editable}
                          />
                        </TableCell>
                      </TableRow>

                      {/* Row 10 */}
                      <TableRow>
                        <TableCell sx={cellHeader}>Best Day(s) to Cover</TableCell>
                        <TableCell colSpan={2} sx={cellInput}>
                          <TableTextField
                            value={row?.best_day_to_cover}
                            name='best_day_to_cover'
                            placeholder='Best Day(s) to Cover'
                            editable={editable}
                          />
                        </TableCell>
                        <TableCell sx={cellHeader}>Best Time to Cover</TableCell>
                        <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                          <TableTextField
                            type='text'
                            name='best_time_to_cover'
                            value={row?.best_time_to_cover}
                            placeholder='Best Time to Cover'
                            editable={editable}
                          />
                        </TableCell>
                      </TableRow>

                      {/* Row 10 */}
                      <TableRow>
                        <TableCell sx={cellHeader}>Ave. Non Senior Px/Day</TableCell>
                        <TableCell colSpan={1} sx={cellInput}>
                          <TableTextField
                            value={row?.ave_non_senior}
                            name='ave_non_senior'
                            placeholder='Ave. Non Senior Px/Day'
                            editable={editable}
                          />
                        </TableCell>
                        <TableCell colSpan={1} sx={cellInput}>
                          <TableTextField
                            value={row?.ave_non_senior}
                            name='ave_non_senior'
                            placeholder='Ave. Non Senior Px/Day %'
                            editable={editable}
                          />
                        </TableCell>
                        <TableCell sx={cellHeader}>Ave. Senior Px/Day</TableCell>
                        <TableCell colSpan={2} sx={cellInput}>
                          <TableTextField
                            value={row?.ave_senior}
                            name='ave_senior'
                            placeholder='Ave. Senior Px/Day'
                            editable={editable}
                          />
                        </TableCell>
                        <TableCell colSpan={2} sx={cellInput}>
                          <TableTextField
                            value={row?.ave_senior}
                            name='ave_senior'
                            placeholder='Ave. Senior Px/Day %'
                            editable={editable}
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Grid item md={4} marginBottom={2}>
            <TableContainer component={Paper} sx={{ width: '100%' }}>
              <Table>
                <TableBody>
                  {/*  */}
                  <TableRow sx={{ backgroundColor: '#f0df47ff' }}>
                    <TableCell colSpan='100%' sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                      HOSPITAL AFFILIATION
                    </TableCell>
                  </TableRow>
                  {/*  */}
                  {professionalform?.hospital_affiliations?.length > 0 ? (
                    <>
                      {professionalform?.hospital_affiliations?.map((row) => (
                        <>
                          <TableRow>
                            <TableCell
                              colSpan={6}
                              sx={{
                                border: '1px solid #999',
                                padding: 0,
                                height: 52,
                                backgroundColor: '#cae7ecff',
                              }}
                            >
                              <TableTextField
                                value={row?.hospital?.name}
                                name='clinic_name'
                                placeholder='N/A'
                                editable={editable}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={cellHeader}>Position/Role</TableCell>
                            <TableCell colSpan={2} sx={cellInput}>
                              <TableTextField
                                value={row?.position_role}
                                name='position_role'
                                placeholder='Position/Role'
                                editable={editable}
                              />
                            </TableCell>
                            <TableCell sx={cellHeader}>Status</TableCell>
                            <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                              <TableTextField
                                type='text'
                                name='status'
                                value={row?.status}
                                placeholder='Status'
                                editable={editable}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={cellHeader}>Street/Building No.</TableCell>
                            <TableCell colSpan={4} sx={cellInput}>
                              <TableTextField
                                value={row?.address_st_bldg_name}
                                name='address_st_bldg_name'
                                placeholder='Street/Building No.'
                                editable={editable}
                              />
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={cellHeader}>City</TableCell>
                            <TableCell colSpan={2} sx={cellInput}>
                              <TableTextField
                                value={row?.hospital?.address_city}
                                name='city'
                                placeholder='City'
                                editable={editable}
                              />
                            </TableCell>
                            <TableCell sx={cellHeader}>Province</TableCell>
                            <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                              <TableTextField
                                type='text'
                                name='address_province'
                                value={row?.hospital?.address_province}
                                placeholder='Province'
                                editable={editable}
                              />
                            </TableCell>
                          </TableRow>
                        </>
                      ))}{' '}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan='100%' sx={{ textAlign: 'center' }}>
                        NO DATA FOUND
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TableContainer component={Paper} sx={{ width: '100%', marginTop: '20px' }}>
              <Table>
                <TableBody>
                  {/*  */}
                  <TableRow sx={{ backgroundColor: '#f0df47ff' }}>
                    <TableCell colSpan='100%' sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                      ORGANIZATION AFFILIATION
                    </TableCell>
                  </TableRow>
                  {/*  */}
                  {professionalform?.organization_affiliations?.length > 0 ? (
                    <>
                      {professionalform?.organization_affiliations?.map((row) => (
                        <>
                          <TableRow>
                            <TableCell
                              colSpan={6}
                              sx={{
                                border: '1px solid #999',
                                padding: 0,
                                height: 52,
                                backgroundColor: '#cae7ecff',
                              }}
                            >
                              <TableTextField
                                value={row?.name}
                                name='clinic_name'
                                placeholder='N/A'
                                editable={editable}
                              />
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell sx={cellHeader}>Membership Type</TableCell>
                            <TableCell colSpan={2} sx={cellInput}>
                              <TableTextField
                                value={row?.position}
                                name='membership_type'
                                placeholder='Membership Type'
                                editable={editable}
                              />
                            </TableCell>
                            <TableCell sx={cellHeader}>Status</TableCell>
                            <TableCell colSpan={3} sx={{ ...cellInput, color: 'gray' }}>
                              <TableTextField
                                type='text'
                                name='status'
                                value={row?.position_status}
                                placeholder='Status'
                                editable={editable}
                              />
                            </TableCell>
                          </TableRow>
                        </>
                      ))}{' '}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan='100%' sx={{ textAlign: 'center' }}>
                        NO DATA FOUND
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TableContainer component={Paper} sx={{ width: '100%', marginTop: '20px' }}>
              <Table>
                <TableBody>
                  {/*  */}
                  <TableRow sx={{ backgroundColor: '#f0df47ff' }}>
                    <TableCell colSpan='100%' sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                      FELLOWSHIP/TRAININGS
                    </TableCell>
                  </TableRow>
                  {/*  */}

                  {professionalform?.fellowships?.length > 0 ? (
                    <>
                      {professionalform?.fellowships?.map((row) => (
                        <>
                          <TableRow>
                            <TableCell
                              colSpan={2}
                              sx={{
                                border: '1px solid #999',
                                padding: 0,
                                height: 52,
                              }}
                            >
                              <TableTextField
                                value={row?.name}
                                name='Name'
                                placeholder='N/A'
                                editable={editable}
                              />
                            </TableCell>
                            <TableCell
                              colSpan={2}
                              sx={{
                                border: '1px solid #999',
                                padding: 0,
                                height: 52,
                              }}
                            >
                              <TableTextField
                                value={row?.institution}
                                name='institution'
                                placeholder='N/A'
                                editable={editable}
                              />
                            </TableCell>
                            <TableCell
                              colSpan={2}
                              sx={{
                                border: '1px solid #999',
                                padding: 0,
                                height: 52,
                              }}
                            >
                              <TableTextField
                                value={row?.institution_city}
                                name='institution_city'
                                placeholder='N/A'
                                editable={editable}
                              />
                            </TableCell>
                          </TableRow>
                        </>
                      ))}{' '}
                    </>
                  ) : (
                    <TableRow>
                      <TableCell colSpan='100%' sx={{ textAlign: 'center' }}>
                        NO DATA FOUND
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
